import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthAccessProvider } from '../core/core.auth';
import { MessageProvider } from '../service/message.service'
import { PresenzeService } from '../service/presenze.service';
import { ActivityService } from '../service/activity.service';
import { AnomalieService } from '../service/anomalie.service';
import { UserService } from '../service/user.service';
import { GlobalFilterService } from '../service/global-filter.service';
import { TaskService } from '../service/task.service';
import { Router } from '@angular/router';
import { UserContext, BaseComponent, UserInfo, CheckhrUser, Document } from '../core/core.component';
import { Subject } from 'rxjs/Subject';
import { CheckhrService } from 'app/service/checkhr.service';
import { ActivitiesComponent } from 'app/activities/activities.component';
import { DocumentService } from 'app/service/document.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [PresenzeService, ActivityService, TaskService],
  host: { '(window:keydown)': 'shortcutHandler($event)' },
})
export class HomeComponent extends BaseComponent implements OnInit {

  @ViewChild(ActivitiesComponent)
  private activitiesComponent: ActivitiesComponent;
  userContext: UserContext;
  userInfo: UserInfo;
  public today: Date;
  flagAnomalie: boolean = false;
  blockedAnomalie: boolean = false;
  switchAnomalie: boolean = false;
  switchScadenze: boolean = false;
  displayPresences: string = "";
  displayAnomalies: string = "";
  displayActivities: string = "";
  presencesInitialized: boolean = false;
  activitiesInitialized: boolean = false;
  anomaliesInitialized: boolean = false;
  styleClassAnomaliesAlert: string = "alert alert-warning";
  anomaliesCounter: number = 0;
  checkhrAlerts: number = 0;
  scadenze: CheckhrUser[];
  enableOpenDetail: boolean = false;
  unreadDocuments: Document[] = [];
  private unreadMaxItems: number = 5;

  refreshAnomalies: Subject<boolean> = new Subject<boolean>();
  refreshPresences: Subject<boolean> = new Subject<boolean>();
  refreshActivities: Subject<boolean> = new Subject<boolean>();

  fullScreen: boolean = false;

  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private anomalieService: AnomalieService,
    private userService: UserService,
    private taskService: TaskService,
    private filterService: GlobalFilterService,
    private presenceService: PresenzeService,
    private documentService: DocumentService,
    private datePipe: DatePipe,
    private checkhrService: CheckhrService) {
    super(authAccess, router, messageProvider);
    this.today = new Date();
    this.messageProvider.clearAll();
  }

  ngOnInit() {
    this.filterService.getGlobalFilter().subscribe(filter => {
      if (filter) {
        this.activitiesInitialized = true;
        this.presencesInitialized = true;
      }
    });
    this.presenceService.selectPresenceSectionEvent().subscribe(
      value => {
        if (value) {
          this.display("presences");
        }
      });
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext != null) {
      this.loadAnomalie();
      this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
        result => {
          this.documentService.getDocuments(this.userContext.srmToken).subscribe((data) => {
            this.unreadDocuments = data.list
              .filter((raw) => !raw.read)
              .map((raw) => new Document(raw))
              .sort((a, b) => b.uploadDate.getTime() - a.uploadDate.getTime())
              .slice(0, this.unreadMaxItems);
          });
          this.userInfo = result;
          if (this.userInfo.managedUsers.length > 0 && this.userInfo.managedUsers.indexOf(this.userContext.userId) < 0) {
            this.userInfo.managedUsers.push(this.userContext.userId);
          }
          if (this.userInfo.admin) {
            this.fullScreen = true;
            this.display("presences");
          } else {
            this.display("activities");
            this.loadCheckhrAlerts();
          }
        },
        error => {
          this.handleError(error);
        }
      );
    }
    else {
      this.authAccess.invalidate();
    }
  }

  formatDate(date: Date): string {
    const datePart = this.datePipe.transform(date, 'dd-MM-yyyy');
    const timePart = this.datePipe.transform(date, 'HH:mm');
    return `${datePart} alle ${timePart}`;
  }

  loadAnomalie() {
    this.anomalieService.getAnomalieForCurrentUser(this.userContext.srmToken).
      subscribe(
        result => {
          this.blockedAnomalie = false;
          this.styleClassAnomaliesAlert = "alert alert-warning";
          this.flagAnomalie = result.userAnomalies.length != 0;
          for (let i = 0; i < result.userAnomalies.length; ++i) {
            if (result.userAnomalies[i].blocking == true) {
              this.styleClassAnomaliesAlert = "alert alert-danger";
              this.blockedAnomalie = true;
              break;
            }
          }
        },
        error => {
          this.handleError(error);
        });
  }

  showAnomalie() {
    this.switchAnomalie = true;
  }
  hideAnomalie() {
    this.switchAnomalie = false;
  }

  showScadenze() {
    if (!this.scadenze) {
      this.checkhrService.getCheckhrAlertsList(this.userContext.srmToken).
        subscribe(
          result => {
            this.scadenze = result.checkhrs;
            this.switchScadenze = true;
          },
          error => {
            this.handleError(error);
          });
    } else {
      this.switchScadenze = true;
    }
  }
  hideScadenze() {
    this.switchScadenze = false;
  }

  display(section: string) {
    this.displayPresences = "";
    this.displayActivities = "";
    this.displayAnomalies = "";
    if (section == "presences") {
      this.displayPresences = "active";
      this.presencesInitialized = true;
    } else if (section == "activities") {
      this.displayActivities = "active";
      this.activitiesInitialized = true;
      this.enableOpenDetail = true;
    } else if (section == "anomalies") {
      this.displayAnomalies = "active";
      this.anomaliesInitialized = true;
    }
  }

  toggleSize(fullsize: boolean) {
    this.fullScreen = fullsize;
  }

  refreshDailyPresence(idPresence: number) {
    this.refreshPresences.next(true);
    this.refreshAnomalies.next(true);
    this.loadAnomalie();
  }

  refreshDailyActivity(idActivity: number) {
    this.refreshActivities.next(true);
    this.refreshAnomalies.next(true);
    this.loadAnomalie();
  }

  refreshAnomaliesCounter(counter: number) {
    this.anomaliesCounter = counter;
  }

  notifyCreationTask(taskId: number) {
    if (taskId > 0) {
      this.taskService.notifyCreationTask(taskId);
    }
  }

  openGlobalFilter() {
    this.filterService.openGlobalFilter();
  }

  loadCheckhrAlerts() {
    this.checkhrService.getCheckhrAlertsCount(this.userContext.srmToken).subscribe(
      result => {
        const alerts = parseInt(result.message, 10);
        if (!isNaN(alerts)) {
          this.checkhrAlerts = alerts;
        }
      },
      error => {
        this.handleError(error);
      });
  }

  getScadenzaRowClass(current: CheckhrUser) {
    let styleClass = '';
    if (+new Date(current.dataScadenza) < +this.today) {
      let maxData: Date = null;
      for (const element of this.scadenze) {
        if (element.idElCheckhr === current.idElCheckhr && element.idUser === current.idUser) {
          maxData = (maxData == null || +new Date(maxData) < +new Date(element.data)) ? element.data : maxData;
        }
      }
      if (current.data === maxData) {
        styleClass += 'inScadenza ';
      } else {
        styleClass += 'scaduto ';
      }
    } else {
      if ((new Date(current.dataScadenza).getTime() - (1000 * 60 * 60 * 24 * current.elCheckhr.numGiorniAlert)) < +this.today) {
        styleClass += 'inScadenza ';
      }
    }
    return styleClass;
  }

  changeEnableShortcut(enable: boolean) {
    this.enableOpenDetail = enable;
  }

  shortcutHandler(event) {
    // INS
    if (this.displayActivities == "active" && event.keyCode == 45 && this.enableOpenDetail == true) {
      this.activitiesComponent.openDetail(null);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts